import { InputGroup, InputGroupAddon, InputGroupText } from '@azelis/ui/components/input-group';
import { Paperclip } from 'lucide-react';

export function FileUploadField({
  accept,
  emptyText = 'No file chosen',
  files,
  id,
  invalid,
  label = 'Attach File',
  multiple,
  onFilesChange,
}: {
  accept?: string;
  emptyText?: string;
  files: Array<File>;
  id: string;
  invalid?: boolean;
  label?: string;
  multiple?: boolean;
  onFilesChange: (files: Array<File>) => void;
}) {
  const summary =
    files.length === 0
      ? emptyText
      : files.length === 1
        ? (files[0]?.name ?? emptyText)
        : `${files.length} files selected`;

  return (
    <InputGroup className="gap-2">
      <InputGroupAddon
        aria-hidden
        className="pointer-events-none text-foreground"
      >
        <Paperclip />
        {label}
      </InputGroupAddon>
      <InputGroupText
        aria-hidden
        className="min-w-0 flex-1 truncate"
      >
        {summary}
      </InputGroupText>
      <input
        accept={accept}
        aria-invalid={invalid || undefined}
        className="absolute inset-0 cursor-pointer opacity-0"
        data-slot="input-group-control"
        id={id}
        multiple={multiple}
        type="file"
        onChange={(event) => {
          onFilesChange(Array.from(event.target.files ?? []));
        }}
      />
    </InputGroup>
  );
}
